// planUpdateJob (2026-10-22, Phase 1 chat-edit safety) — a chat plan edit the backend QUEUED
// (flag CHAT_REVISE_JOB_STATUS) is not an update yet. Poll its job until the outcome is final and
// only then tell the athlete: success + plan refresh only when the write actually committed
// (result_meta.applied === true); otherwise the backend's own explanation, and the global banner
// closes without claiming success.

const SAVED_FALLBACK = '✅ התכנית עודכנה ונשמרה.';
const FAILED_FALLBACK = 'לא הצלחתי לעדכן את התכנית הפעם. אפשר לנסות שוב.';
export const LOST_TEXT = "לא הצלחתי לבדוק אם השינוי נשמר. בדוק בעוד דקה במסך 'תכנית אימונים'.";
// No "try again" here: the edit may still be committing — asking again could apply it twice.
export const SLOW_TEXT = "⏳ לא קיבלתי עדיין אישור שהשינוי נשמר. בדוק בעוד דקה במסך 'תכנית אימונים' — "
  + "אם הוא לא מופיע, כתוב לי ואבדוק.";

/**
 * fetchJob(jobId) → { status: number, body?: object } (the /plan-status/{id} response).
 * onMessage(text): append a coach bubble. onPlansUpdated(planId): refresh the plan views.
 * onBanner(detail): close the global banner — {success:true} | {success:false} | {dismiss:true}.
 * Resolves to the final outcome: 'applied' | 'not_applied' | 'failed' | 'lost' | 'timeout'.
 */
export async function watchPlanUpdateJob({
  jobId, fetchJob, onMessage, onPlansUpdated, onBanner,
  wait = (ms) => new Promise((r) => setTimeout(r, ms)), intervalMs = 3000, maxTries = 60,
}) {
  for (let i = 0; i < maxTries; i += 1) {
    await wait(intervalMs);
    let res;
    try {
      res = await fetchJob(jobId);
    } catch {
      continue;                                 // network blip — keep polling
    }
    if (res && res.status === 404) {
      onMessage(LOST_TEXT);
      onBanner({ dismiss: true });
      return 'lost';
    }
    const job = res && res.status === 200 ? res.body || {} : null;
    if (!job || (job.status !== 'completed' && job.status !== 'failed')) continue;
    const meta = job.result_meta || {};
    const applied = job.status === 'completed' && meta.applied === true;
    const failed = job.status === 'failed' || meta.outcome === 'failed';
    onMessage(meta.message_he || (applied ? SAVED_FALLBACK : FAILED_FALLBACK));
    if (applied) {
      onPlansUpdated(job.plan_id);
      onBanner({ success: true });
      return 'applied';
    }
    onBanner(failed ? { success: false } : { dismiss: true });
    return failed ? 'failed' : 'not_applied';
  }
  onMessage(SLOW_TEXT);
  onBanner({ dismiss: true });
  return 'timeout';
}
